import React from 'react'
import { Box, Drawer, drawerClasses } from '@mui/material'
import Sidebar from './menu/Sidebar'
import LKQBackground from 'assets/svg/lkq-background.svg'

export const Container: React.FC<{}> = props => {
  const drawerWidth = '208px'
  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={{
          backgroundColor: '#000',
          height: '100vh',
          width: drawerWidth,
          position: 'fixed',
          backgroundImage: `url(${LKQBackground})`,
          backgroundSize: 'auto 60%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom right',
          '&::after': {
            content: "''",
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)'
          }
        }}
      >
        <Drawer
          className='main-content'
          variant='permanent'
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            border: 0,
            [`& .${drawerClasses.paper}`]: {
              width: drawerWidth,
              boxSizing: 'border-box',
              backgroundColor: 'transparent',
              border: 0
            }
          }}
        >
          <Sidebar />
        </Drawer>
      </Box>
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          ml: drawerWidth,
          width: `calc(100% - ${drawerWidth})` /* full page size minus the 208px menu bar  */
        }}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export default Container
